{
  "companyGroups": {
    "header": "Organisationer",
    "showOrganisations": "Visa organisationer →",
    "yourOrganisation": "Din organisation",
    "uploadLogo": "Ladda upp företagslogotyp",
    "replaceLogo": "Byt företagslogotyp",
    "editName": "Ändra organisationens namn",
    "create": {
      "button": "Ny organisation",
      "title": "Ny organisation",
      "nameLabel": "Organisationens namn",
      "parentLabel": "Överordnad organisation",
      "superadminTitle": "Första superadmin",
      "superadminDescription": "Bjud in användaren som ska administrera den nya organisationen. Hen får ett inbjudningsmejl.",
      "ownEmailWarning": "Detta är din egen e-postadress. En e-postadress kan bara tillhöra en organisation — använder du den här låses du ute från ditt konto."
    }
  }
}
